import { z } from 'zod';

export const IssueEvidenceKindSchema = z.enum([
  'network_error',
  'console_error',
  'visual',
  'agent_thought',
  'timeline_event',
  'history_comparison',
  'before_after',
  'code_reference',
  'log_reference',
]);
export type IssueEvidenceKind = z.infer<typeof IssueEvidenceKindSchema>;

export const IssueLogSystemSchema = z.enum(['sentry', 'cloudwatch', 'datadog', 'other']);
export type IssueLogSystem = z.infer<typeof IssueLogSystemSchema>;

const EVIDENCE_ID_LIMIT = 1024;
const EVIDENCE_TEXT_LIMIT = 4000;
const EVIDENCE_DETAIL_LIMIT = 16000;

export const FailureDiagnosticEvidenceSchema = z.object({
  type: IssueEvidenceKindSchema,
  timestamp: z.number().optional(),
  description: z.string().max(EVIDENCE_TEXT_LIMIT),
  detail: z.string().max(EVIDENCE_DETAIL_LIMIT).optional(),
  frameStorageKey: z.string().max(EVIDENCE_ID_LIMIT).optional(),

  /** Short representative video clip extracted from the run recording (MP4). */
  clipStorageKey: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  /** Where the clip starts, in video-relative ms (same scale as `timestamp`). */
  clipStartMs: z.number().optional(),
  /** Duration of the (possibly tightened) clip in ms. */
  clipDurationMs: z.number().optional(),

  beforeFrameStorageKey: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  beforeCaption: z.string().max(EVIDENCE_TEXT_LIMIT).optional(),
  beforeTimestamp: z.number().optional(),
  beforeRunId: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  afterFrameStorageKey: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  afterCaption: z.string().max(EVIDENCE_TEXT_LIMIT).optional(),
  afterTimestamp: z.number().optional(),
  afterRunId: z.string().max(EVIDENCE_ID_LIMIT).optional(),

  repo: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  path: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  line: z.number().int().optional(),
  endLine: z.number().int().optional(),
  commit: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  permalink: z.string().max(EVIDENCE_TEXT_LIMIT).optional(),
  symbol: z.string().max(EVIDENCE_ID_LIMIT).optional(),

  logSystem: IssueLogSystemSchema.optional(),
  query: z.string().max(EVIDENCE_TEXT_LIMIT).optional(),
  logId: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  traceId: z.string().max(EVIDENCE_ID_LIMIT).optional(),
  url: z.string().max(EVIDENCE_TEXT_LIMIT).optional(),
});
export type FailureDiagnosticEvidence = z.infer<typeof FailureDiagnosticEvidenceSchema>;
